var map = {
	"./anker-ai.jpg": 8179,
	"./anker.jpg": 6942,
	"./astroboy-ai.jpg": 2835,
	"./astroboy.jpg": 7150,
	"./bally-ai.jpg": 7920,
	"./bally.jpg": 9159,
	"./blue.jpg": 8015,
	"./chapatte-ai.jpg": 2496,
	"./chapatte.jpg": 2887,
	"./cows-ai.jpg": 2088,
	"./cows.jpg": 5343,
	"./drstrange-ai.jpg": 7290,
	"./drstrange.jpg": 2477,
	"./erni-ai.jpg": 9614,
	"./erni.jpg": 5025,
	"./fischer-ai.jpg": 8662,
	"./fischer.jpg": 3081,
	"./giacometti-ai.jpg": 3334,
	"./giacometti.jpg": 6889,
	"./green.jpg": 8926,
	"./hodler-ai.jpg": 9654,
	"./hodler.jpg": 2297,
	"./klee-ai.jpg": 6309,
	"./klee.jpg": 3356,
	"./moebius-ai.jpg": 9034,
	"./moebius.jpg": 8397,
	"./oppenheim-ai.jpg": 8007,
	"./oppenheim.jpg": 978,
	"./otomo-ai.jpg": 6408,
	"./otomo.jpg": 8991,
	"./pipette-ai.jpg": 8419,
	"./pipette.jpg": 6414,
	"./saintphalle-ai.jpg": 8111,
	"./saintphalle.jpg": 5034,
	"./servers-ai.jpg": 6500,
	"./servers.jpg": 8683,
	"./taeuberarp-ai.jpg": 4787,
	"./taeuberarp.jpg": 4302,
	"./tesson-ai.jpg": 7472,
	"./tesson.jpg": 7143,
	"./tinguely-ai.jpg": 7461,
	"./tinguely.jpg": 1324,
	"./wassmer-ai.jpg": 990,
	"./wassmer.jpg": 3297
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3907;